/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { makeStyles } from 'tss-react/mui';

import { Grid, Typography } from '@mui/material';

import AuthService from 'services/AuthService';
import { isNotPremium } from 'commons/utils/accountUtils';
import { currentUserSelector, useAppStore } from 'stores/appStore';

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  content: {
    paddingTop: 150,
    textAlign: 'center',
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560,
  },
}));

function NotAuthorizedPage() {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <Grid container justifyContent="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.content}>
            <Typography variant="h1">403: Você não está autorizado a acessar está página.</Typography>
            <Typography variant="subtitle2">
              Você pode ter chegado aqui por engano ou por acidente. Em caso de dúvida contate a equipe de
              suporte.
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

// COMPONENT
function RouteWithLayout({
  layout: Layout,
  component: Component,
  privateRoute,
  requiredRoles,
  requiresPremiumAcc,
  showLoginBtn,
  showUserWelcomeMsg,
  ...rest
}) {
  const currentUser = useAppStore(currentUserSelector);
  const isLoggedIn = AuthService.isUserLoggedIn(currentUser);
  const notPremium = isNotPremium(currentUser);
  const location = useLocation();

  const ComponentToDisplay = AuthService.isAuthorized(currentUser?.roles, requiredRoles)
    ? Component
    : NotAuthorizedPage;

  if (privateRoute && !isLoggedIn) {
    return (
      <Navigate
        to={{
          pathname: '/login',
        }}
        state={{ from: location }}
      />
    );
  }

  if (requiresPremiumAcc && isLoggedIn && notPremium) {
    return (
      <Navigate
        to={{
          pathname: '/configuracoes',
          state: { infoMessage: 'Adquira uma conta premium para aproveitar todas funcionalidades.' },
        }}
      />
    );
  }

  return <ComponentToDisplay />;
}

RouteWithLayout.defaultProps = {
  privateRoute: false,
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  privateRoute: PropTypes.bool,
};

export default RouteWithLayout;
